import api from '~services/axios';

export default {
  // 首页客户统计
  apiGetHomeCustom: params => api.get('/api/home/customer', { params }),
  // 首页商机统计
  apiGetHomeBusi: params => api.get('/api/home/business', { params }),
  // 首页合同统计
  apiGetHomeContract: params => api.get('/api/home/contract', { params }),
  // 首页客户跟进统计
  apiGetHomeCustomVisit: params => api.get('/api/home/visit', { params }),
  // 首页销售漏斗
  apiGetHomeChartData: params => api.get('/api/home/businesstype', { params }),
  // 首页项目统计
  apiGetHomeProject: params => api.get('/api/home/project', { params }),
  // 首页-医生客户统计查看
  apiGetHomeMedicalCustomer: params =>
    api.get('/api/home/medicalCustomer', { params }),
};
